import { defineAsyncComponent } from "vue";
export default [
  {
    name: "AssessmentAttemptWaitingRoom",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerWaitingRoom"),
    ),
    path: "waiting-room",
    props: true,
  },
  {
    name: "AssessmentAttemptPaused",
    component: defineAsyncComponent(() => import("@modules/attempt/components/AssignmentPaused")),
    path: "paused",
    props: true,
  },
  {
    name: "AssessmentAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AssessmentAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AssessmentAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "module/:moduleUuid/section/:sectionId",
    props: true,
  },
  {
    name: "AssessmentAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "module/:moduleUuid/section/:sectionId/end",
    props: true,
  },
  {
    name: "AssessmentAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId",
    props: (route) => ({
      pageId: route.params.pageId,
      openAnnotation: route.query.openAnnotation,
    }),
  },
  {
    name: "AssessmentAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "AssessmentAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "AssessmentAttemptPasscode",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonPasscode")),
    path: "passcode",
    props: true,
  },
  {
    path: "not-found",
    name: "AssessmentAttemptNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
